import React from 'react';
import './index.css';
import { tools } from '../../tools/tools';

export const Toolbar = ({ onToolClick }) => {
  return (
    <div className='toolbar'>
      {tools.map((tool, i) => (
        <div onClick={() => onToolClick(tool.id)} key={i} className='tool-box'>
          <div className='toolIcon-box'>
            <img src={tool.icon} alt={tool.title} />
          </div>
          <div className='toolText-box'>
            <h1>{tool.titleUz}</h1>
            <p>{tool.titleEng}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
